import React from 'react';
import { AlertCircle } from 'lucide-react';

export const invoiceInputClass = 'esave-input';
export const invoiceLabelClass = 'esave-label';
export const invoiceButtonClass = 'esave-button';
export const invoicePrimaryButtonClass = 'esave-button esave-button-primary';
export const invoiceDetailsClass = 'esave-details';

export function InvoicePanel({ title, icon: Icon, children, className = '', tour }) {
    return <section data-tour={tour} className={`esave-panel ${className}`}>
        <div className="esave-panel-heading">
            {Icon && <Icon size={18} aria-hidden="true" />}<h3>{title}</h3>
        </div>
        <div className="esave-panel-body">{children}</div>
    </section>;
}

export function InvoiceNotice({ children, tone = 'amber', role, icon: Icon = AlertCircle, tour }) {
    return <div data-tour={tour} role={role} className={`esave-notice esave-notice-${tone}`}>
        <Icon size={20} className="shrink-0 mt-0.5" aria-hidden="true" />
        <div className="min-w-0 flex-1 space-y-2 break-words">{children}</div>
    </div>;
}
